/**
 * @name results.controller:MoveTopOnFocus
 * @description
 * # MoveTopOnFocus
 * Add focus element handler to move it to the top of the screen
 */
import { mobileDetect } from 'rp-gui-guide';

export default function ($scope, $element) {
    'ngInject';

    let headerOffset = 0;
    let header;
    let searchBody;
    let searchContainer;
    let offsetTop;

    this.mobileDetect = mobileDetect;

    const hideHeader = () => {
        headerOffset = header.height();
        header.hide();
    };

    const moveBodyToTop = () => {
        searchBody
            .offset({ top: -offsetTop })
            .css('padding-bottom', offsetTop * 2 + headerOffset);
    };

    const restoreBodyOffset = () => {
        searchBody
            .offset({ top: headerOffset })
            .css('padding-bottom', 0);
    };

    const getSearchBodyClientOffset = () => parseInt(
        $('.js-advancedSearch__form').css('margin-top'), 10
    );

    const restoreView = (e) => {
        if (e.target !== $element[0]) {
            header.show();
            restoreBodyOffset();
            searchContainer.off('click', restoreView);
            this.init();
        }
    };

    this.focusElementHandler = () => {
        searchContainer = $('.js-advancedSearch');
        searchBody = $('#searchBody');
        header = $('.js-advancedSearch__header');
        hideHeader();
        offsetTop = getSearchBodyClientOffset();
        moveBodyToTop();
        searchContainer.on('click', restoreView);
    };

    this.init = () => {
        if (this.mobileDetect.os() === 'AndroidOS') {
            $element.one('focus', this.focusElementHandler);
        }
    };

    this.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveMoveTopOnFocus.js